export const presets = {
    slide: {
        block: {
            enter: (direction) => {
                return {
                    x: direction == 'right' ? '100%' : '-100%',
                    /*type: 'spring', 
                    stiffness: 80, 
                    damping: 15,
                    restDelta: 0.03,
                    duration: 1
                    //bounce: 0.8*/
                };
            },
            center: {
                zIndex: 1,
                x: 0,
                /*type: 'spring', 
                stiffness: 80, 
                damping: 15,
                restDelta: 0.03,
                duration: 1*/
            },
            exit: (direction) => {
                return {
                    zIndex: 0,
                    x: direction == 'left' ? '100%' : '-100%',
                    /*type: 'spring', 
                    stiffness: 80, 
                    damping: 15,
                    restDelta: 0.03,
                    duration: 1*/
                };
            }
        },
        media: {
            enter: (direction) => null,
            center: null,
            exit: (direction) => null
        },
        content: {
            enter: (direction) => {
                return {
                    opacity: 0
                };
            },
            center: {
                opacity: 1
            },
            exit: (direction) => {
                return {
                    opacity: 0
                };
            }
        }
    },
    fade: {
        block: {
            enter: (direction) => {
                return {
                    opacity: 0
                };
            },
            center: {
                zIndex: 1,
                opacity: 1
            },
            exit: (direction) => {
                return {
                    zIndex: 0,
                    opacity: 0
                };
            }
        },
        media: {
            enter: (direction) => null,
            center: null,
            exit: (direction) => null
        },
        content: {
            enter: (direction) => null,
            center: null,
            exit: (direction) => null
        },
    },
    rotate: {
        block: {
            enter: (direction) => {
                return {
                    opacity: 0
                };
            },
            center: {
                zIndex: 1,
                opacity: 1
            },
            exit: (direction) => {
                return {
                    zIndex: 0,
                    opacity: 0
                };
            }
        },
        media: {
            enter: (direction) => {
                return {
                    rotate: direction == 'right' ? -15 : 15,
                    scale: 2
                };
            },
            center: {
                zIndex: 1,
                rotate: 0, 
                scale: 1
            },
            exit: (direction) => {
                return {
                    zIndex: 0,
                    rotate: direction == 'right' ? -15 : 15,
                    scale: 2
                };
            }
        },
        content: {
            enter: (direction) => null,
            center: null,
            exit: (direction) => null
        },
    }
}


export const dragPreset = {
    enter: (direction) => {
        return {
            x: direction == 'right' ? '100%' : '-100%',
            opacity: 0
        };
    },
    center: {
        zIndex: 1,
        x: 0,
        opacity: 1
    },
    exit: (direction) => {
        return {
            zIndex: 0,
            x: direction == 'left' ? '100%' : '-100%',
            opacity: 0
        };
    }
}



export function getPreset(name, element = 'block') {
    let preset = presets[name][element]

    //preset = {
        //...preset.transition,
        //...transition
    //}


    return preset;
}